module.exports = __webpack_public_path__ + "img/svg/cart-ef57249c.svg";